module.exports = __webpack_public_path__ + "img/logo-volvo.751bf849.svg";